"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tzPattern = void 0;
/** Regex to identify the presence of a time zone specifier in a date string */
exports.tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
